
import { defineComponent } from "vue";
import { footerWidthFluid } from "@/core/helpers/config";

export default defineComponent({
  name: "KTFooter",
  setup() {
    const copyRight = process.env.VUE_APP_COPY_RIGTH;

    return {
      copyRight,
      footerWidthFluid
    };
  }
});
